export default function initializeTeam() {
    document.querySelectorAll('.block-zespol').forEach(function (block) {
        new Team(block);
    });
}

class Team {
    constructor(block) {
        this.block = block;
        this.grid = block.querySelector('.block-team__grid');
        this.init();
    }

    getColumns() {
        if (!this.grid) {
            return 1;
        }

        const columns = getComputedStyle(this.grid).gridTemplateColumns.split(' ').filter(Boolean);

        return columns.length || 1;
    }

    openPanel(panel) {
        // display:none removes the panel from the grid flow entirely (so closed
        // items don't force an extra row); switch it back to a real grid item
        // and force a reflow before animating so the transition actually plays.
        panel.style.display = 'block';
        void panel.offsetHeight;
        panel.classList.add('active');
    }

    closePanel(panel) {
        if (!panel.classList.contains('active')) {
            panel.style.display = 'none';
            return;
        }

        panel.classList.remove('active');

        const onTransitionEnd = (event) => {
            if (event.propertyName !== 'max-height') {
                return;
            }
            panel.style.display = 'none';
            panel.removeEventListener('transitionend', onTransitionEnd);
        };

        panel.addEventListener('transitionend', onTransitionEnd);
    }

    init() {
        // Track item/toggle/panel by reference (not live queries) since the panel
        // node gets physically moved in the DOM to the end of its grid row.
        const entries = Array.from(this.block.querySelectorAll('.block-team-item')).map((item) => ({
            item,
            toggle: item.querySelector('.block-team-item__toggle'),
            panel: item.querySelector('.block-team-item__panel'),
        }));

        entries.forEach((entry, index) => {
            if (!entry.toggle || !entry.panel) {
                return;
            }

            const panelInner = entry.panel.querySelector('.block-team-item__panel-inner');
            const isEmpty = !panelInner || panelInner.textContent.trim() === '';

            if (isEmpty) {
                entry.toggle.remove();
                entry.panel.remove();
                return;
            }

            entry.toggle.addEventListener('click', () => {
                const isActive = entry.item.classList.contains('active');

                entries.forEach((other) => {
                    other.item.classList.remove('active');
                    if (other.toggle) {
                        other.toggle.setAttribute('aria-expanded', 'false');
                    }
                    if (other.panel) {
                        this.closePanel(other.panel);
                    }
                });

                if (!isActive) {
                    entry.item.classList.add('active');
                    entry.toggle.setAttribute('aria-expanded', 'true');

                    // Move the panel to sit right after the last card in this
                    // item's row, so CSS grid auto-placement doesn't leave a
                    // gap in the row and push later cards down an extra row.
                    const columns = this.getColumns();
                    const rowEndIndex = Math.min(entries.length - 1, Math.ceil((index + 1) / columns) * columns - 1);
                    entries[rowEndIndex].item.insertAdjacentElement('afterend', entry.panel);

                    this.openPanel(entry.panel);
                    entry.panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            });
        });
    }
}
